<!--
  Doré = signal premium, jamais l'orange des avertissements : l'utilisateur ne
  doit pas confondre une invitation avec une alerte de son jardin.

  L'encart ANNONCE ce que Premium débloque à cet endroit précis. Un encart qui
  se contente de dire « Découvrir Premium » demande de la curiosité ; celui-ci
  répond à la question avant qu'elle soit posée.
-->
@if (premiumService.premiumEnabled()) {
<button
  type="button"
  (click)="onClick()"
  class="flex w-full items-start gap-3 rounded-2xl border border-[#F0C97A] bg-gradient-to-r from-[#FFF6E4] to-[#FFEFD1] text-left"
  [ngClass]="compact ? 'px-3 py-2.5' : 'px-4 py-3'"
>
  <span
    class="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#F79400] text-white"
  >
    <vw-lock-icon class="h-4 w-4" />
  </span>

  <span class="min-w-0 flex-1">
    <span
      class="mb-0.5 inline-block rounded-full bg-[#F79400]/15 px-1.5 py-px text-[10px] font-bold uppercase tracking-wide text-[#B36A00]"
    >
      {{ 'premium.teaser.badge' | translate }}
    </span>

    <!-- Deux lignes plutôt qu'une troncature : les traductions allemandes et
         néerlandaises sont nettement plus longues qu'en français, et un encart
         coupé au milieu d'un mot ne vend rien. -->
    <span class="block line-clamp-2 text-sm font-semibold text-[#7A4B00]">{{
      message
    }}</span>

    @if (detail) {
    <span class="mt-0.5 block text-xs leading-snug text-[#A9773A]">{{
      detail
    }}</span>
    } @else {
    <span class="block text-xs text-[#A9773A]">{{ ctaLabel | translate }}</span>
    }
  </span>

  <svg
    class="h-5 w-5 shrink-0 self-center text-[#A9773A]"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M9 6l6 6-6 6"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</button>
}
